import dayjs from "dayjs";

export const convertOrdersToTargetFormat = (orders) => {
  return orders.map((order) => {
    // If we pass in mapped orders with a 'raw' property, use that. Otherwise use the object itself.
    const raw = order.raw || order;

    const address =
      raw.shippingAddress?.fullAddress || raw.customerAddress || '';
    const buyerName =
      raw.shippingAddress?.name || raw.customerName || raw.customer || '';
    const phone =
      raw.shippingAddress?.phone || raw.customerMobile || raw.phone || '';

    const rawDate = raw.info?.createdAt || raw.createdAt || raw.createdDateTime;
    let docDateStr = dayjs().format("YYYY-MM-DDT00:00:00");
    let invcDateStr = dayjs().format("YYYY-MM-DDTHH:mm:ss");

    if (rawDate) {
      const numDate = Number(rawDate);
      let d;
      if (!Number.isNaN(numDate)) {
        if (numDate < 100000000000) {
          d = dayjs(numDate * 1000);
        } else {
          d = dayjs(numDate);
        }
      } else {
        d = dayjs(rawDate);
      }
      if (d.isValid()) {
        docDateStr = d.format("YYYY-MM-DDT00:00:00");
        invcDateStr = d.format("YYYY-MM-DDTHH:mm:ss");
      }
    }

    const docNbr = String(raw.id || "");
    const invcNbr = String(order.invoiceNumber || raw.invoiceNumber || docNbr);

    const rawProducts = raw.products || raw.items || [];
    let productList = [];
    if (Array.isArray(rawProducts)) {
      productList = rawProducts;
    } else if (rawProducts && typeof rawProducts === "object") {
      productList = Object.values(rawProducts);
    }

    const items = productList.map((p) => {
      const qty = Number(p.quantity || p.qty || 1);
      const price = Number(p.price || 0);

      // Simple parse for code like AV003-0011125-10112027
      let invtID = p.productCode || p.code || p.id || "";
      let lotSerNbr = "";
      let expDate = "";

      const singleFormatRegex = /^[A-Za-z]{2}\d{3}-.+-\d+$/;
      if (singleFormatRegex.test(invtID)) {
        const blocks = invtID.split("-");
        const firstBlock = blocks[0].trim();
        invtID = firstBlock.substring(0, 2) + "MTP03010" + firstBlock.slice(-3);
        lotSerNbr = blocks[1].trim();

        const rawHsd = blocks[2].trim();
        if (/^\d{8}$/.test(rawHsd)) {
          const dd = rawHsd.substring(0, 2);
          const mm = rawHsd.substring(2, 4);
          const yyyy = rawHsd.substring(4);
          expDate = `${yyyy}-${mm}-${dd}T00:00:00`;
        }
      }

      return {
        isIncreaseItem: null,
        invtID: invtID,
        invtName: p.productName || p.name || "",
        siteID: "AVMKK1501",
        lotSerNbr: lotSerNbr,
        expDate: expDate,
        quantity: qty,
        convertQuantity: qty,
        unitPrice: price,
        itemTotalAmountWithoutTax: qty * price,
        cashPreTAX: null,
        discountPercentage: null,
        discountAmount: null,
        taxPercentage: 5.0,
        taxAmount: (qty * price) * 0.05,
        discountID: null,
        discountDescr: null,
      };
    });

    return {
      address: address,
      batCode: "017",
      batNbr: `C26MTTC26MTT${invcNbr}`,
      branchID: "HNI",
      branchName: "Công ty Cổ phần Anvy - chi nhánh Hà Nội",
      buyerName: buyerName,
      custID: "AVMKH041886",
      custName: "Bán cho người tiêu dùng",
      docDate: docDateStr,
      docNbr: docNbr,
      geCpnyID: "AVM",
      taxCode: "",
      geCpnyName: "CÔNG TY CỔ PHẦN ANVY",
      invcDate: invcDateStr,
      invcNbr: invcNbr,
      invcNote: "C26MTT",
      invoiceCustID: "01AVMKH041886",
      invoiceCustName: "Bán cho người tiêu dùng",
      items: items,
      origDocDate: null,
      origDocNbr: null,
      ordernbrSalesOrd: null,
      originalInvoice: null,
      type: "IN",
      typeDescr: "Hóa Đơn Bán",
    };
  });
};
